module.exports = __webpack_public_path__ + "static/media/91QpSusdj1L._AC_SL1500_.c128b60f.jpg";